/**
 *
 * ControlPanel
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { map, includes, flatMap, find } from "lodash"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import makeSelectControlPanel from "./selectors"
import reducer from "./reducer"
import saga from "./saga"

import Account from "../Account"
import UserManagement from "../UserManagement"
import ReminderEmails from "../ReminderEmails"
import Configuration from "../Configuration"
import RecordControlPanel from "../RecordControlPanel"
import CustomIndicators from "../CustomIndicators"
import CustomIndicatorsForm from "../CustomIndicators/FormIndicator"
import "./index.less"
import { isModuleBySlug, LOCAL_VISMA_PEOPLE_SYNC_ENABLED } from "../../../utils/storage"
import {
  CUSTOM_INDICATORS,
  EMAILS_AND_NOTIFICATIONS,
  SEGMENTS,
} from "../../../utils/constants"
import Segments from "../Segments"
import { validate } from "../../../utils/functions"
import Security from "../Security"
import Synchronization from "../Synchronization"

const optionsGeneral = [
  { name: "Cuenta", slug: "account" },
  { name: "Sincronización", slug: "synchronization" },
  { name: "Gestión de usuarios", slug: "user-management" },
  { name: "Segmentos", slug: "segments" },
  { name: "Correos recordatorios", slug: "post-reminders" },
  { name: "Seguridad", slug: "security" },
  { name: "Historial", slug: "record" },
]

const slugsAllowed = [
  "#configuration",
  "#other-indicators",
  "#form-indicator",
  "",
]

const formSlugsAllowed = ["#form-indicator"]

const formAvailable = ["indicator"]

/* eslint-disable react/prefer-stateless-function */
export class ControlPanel extends React.Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { history } = this.props
    const { hash: hashPrev } = prevProps.location
    const { hash, pathname } = location

    
    if (hashPrev && hash) {
      if (hashPrev !== hash) {
        const url = !formSlugsAllowed.includes(hash) ? "/control-panel" : pathname;
        history.push(`${url}${hash}`);
      }
    }
  }

  optionActive = (slugName) => {
    let isActive = ""
    const onlySlugs = flatMap(optionsGeneral, (item) => `#${item.slug}`)
    let hashSelected = location.hash
    const isEmailsAndNotifications = isModuleBySlug(EMAILS_AND_NOTIFICATIONS)
    const isSegmentsEnabled = isModuleBySlug(SEGMENTS)
    if (hashSelected === "#post-reminders" && !isEmailsAndNotifications) {
      hashSelected = "#account"
      window.location.hash = "account"
    }
    if (hashSelected === "#segments" && !isSegmentsEnabled) {
      hashSelected = "#account"
      window.location.hash = "account"
    }

    if (["#other-indicators", "#form-indicator"].includes(hashSelected)) {
      hashSelected = "#other-indicators"
    }

    const slugs = [...slugsAllowed, ...formSlugsAllowed]
    if (includes([...onlySlugs, ...slugs], hashSelected)) {
      isActive =
        (hashSelected || "#account") === `#${slugName}`
          ? "container-controlpanel__left-body-option--active"
          : ""
    } else {
      window.location.hash = "account"
    }

    return isActive
  }

  renderContent = () => {
    if (includes(["#account", ""], location.hash)) {
      return <Account />
    }

    if (location.hash === "#user-management") {
      return <UserManagement {...this.props} />
    }

    const isEmailsAndNotifications = isModuleBySlug(EMAILS_AND_NOTIFICATIONS)
    if (location.hash === "#post-reminders" && isEmailsAndNotifications) {
      return <ReminderEmails />
    }
    if (location.hash === "#post-reminders" && !isEmailsAndNotifications) {
      return <Account />
    }

    const isSegmentsEnabled = isModuleBySlug(SEGMENTS)
    if (location.hash === "#segments" && isSegmentsEnabled) {
      return <Segments />
    }
    if (location.hash === "#segments" && !isSegmentsEnabled) {
      return <Account />
    }
    if (location.hash === "#configuration") {
      return <Configuration />
    }
    const isCustomIndicatorsEnabled = isModuleBySlug(CUSTOM_INDICATORS)
    if (location.hash === "#other-indicators" && isCustomIndicatorsEnabled) {
      return <CustomIndicators {...this.props} />
    }

    if (location.hash === "#record") {
      return <RecordControlPanel />
    }

    if (location.hash == "#security") {
      return <Security {...this.props} />
    }

    if (location.hash == "#synchronization") {
      return <Synchronization />
    }

    return <div>No page!</div>
  }

  viewComponent = () => {
    const name = find(
      [
        ...optionsGeneral,
        { name: "Configuración", slug: "configuration" },
        { name: "Indicadores", slug: "other-indicators" },
      ],
      (item) => {
        return `#${item.slug}` === (location.hash || "#account")
      }
    )

    return (
      <div>
        <div className="container-controlpanel__right-title">
          {name && name.name}
        </div>
        <div
          className="container-controlpanel__right-content"
          style={{ height: "calc(100% - 74px)" }}>
          {this.renderContent()}
        </div>
      </div>
    )
  }

  formComponent = (module) => {
    const forms = {
      indicator: <CustomIndicatorsForm {...this.props} />,
    }

    let response = <div>No page!</div>
    if (!validate.empty(module) && formAvailable.includes(module)) {
      response = forms[module]
    }

    return response
  }

  renderContainer = () => {
    const { id, module } = this.props.match.params
    let response = this.viewComponent()

    if (!validate.empty(id)) {
      response = this.formComponent(module)
    }

    return response
  }

  render() {
    const isEmailsAndNotifications = isModuleBySlug(EMAILS_AND_NOTIFICATIONS)
    const isSegmentsEnabled = isModuleBySlug(SEGMENTS)
    const isCustomIndicatorsEnabled = isModuleBySlug(CUSTOM_INDICATORS)
    return (
      <div>
        <Helmet>
          <title>Panel de control</title>
          <meta name="description" content="Description of ControlPanel" />
        </Helmet>
        <div className="container-controlpanel">
          <div className="container-controlpanel__left">
            <div className="container-controlpanel__left-title">GENERAL</div>
            <div className="container-controlpanel__left-body">
              {map(optionsGeneral, ({ name, slug }) => {
                if (slug === "post-reminders" && !isEmailsAndNotifications) {
                  return null
                }
                if (slug === "segments" && !isSegmentsEnabled) {
                  return null
                }
                if(slug === "synchronization" && !LOCAL_VISMA_PEOPLE_SYNC_ENABLED()) {
                  return null
                }
                return (
                  <div
                    onClick={() => (window.location.hash = slug)}
                    className={`container-controlpanel__left-body-option ${this.optionActive(
                      slug
                    )}`}
                    key={slug}>
                    {name}
                  </div>
                )
              })}
            </div>
            <div
              className="container-controlpanel__left-title"
              style={{ marginTop: 56 }}>
              MODELOS
            </div>
            <div
              onClick={() => (window.location.hash = "configuration")}
              className={`container-controlpanel__left-body-option ${this.optionActive(
                "configuration"
              )}`}>
              Configuración
            </div>
            {isCustomIndicatorsEnabled && (
              <div
                onClick={() => (window.location.hash = "other-indicators")}
                className={`container-controlpanel__left-body-option ${this.optionActive(
                  "other-indicators"
                )}`}>
                Indicadores
              </div>
            )}
          </div>
          <div className="container-controlpanel__right">
            {this.renderContainer()}
          </div>
        </div>
      </div>
    )
  }
}

ControlPanel.propTypes = { dispatch: PropTypes.func.isRequired }

const mapStateToProps = createStructuredSelector({
  controlPanel: makeSelectControlPanel(),
})

function mapDispatchToProps(dispatch) {
  return { dispatch }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "controlPanel", reducer })
const withSaga = injectSaga({ key: "controlPanel", saga })

export default compose(withReducer, withSaga, withConnect)(ControlPanel)
